module.exports = __webpack_public_path__ + "static/original-mattress-3-360966c7b753c3cfdaf7934195d1f96f.webp";